import { useEffect, useState } from 'react';
import * as React from 'react';

import { RenderContent } from '@core/components/display/html/RenderContent';
import GhostPage from '@research-api/components/ghost/GhostPage';
import { GhostPostOrPage } from '@research-api/utils/api/ghost/ghost-interfaces';
import { prepareGhostTag } from '@research-api/utils/api/ghost/pages/getPageForAsset';
import getPagesByTag from '@research-api/utils/api/ghost/pages/getPagesByTag';

import PriceSectionHeader from '@/components/pages/price/components/Header/PriceSectionHeader';

type PriceAboutSummaryProps = {
    code: string;
    title: string;
    description: string;
};

const PriceAboutSummary = (props: PriceAboutSummaryProps) => {
    const { code, title, description } = props;
    const [ghostPage, setGhostPage] = useState<GhostPostOrPage | null>(null);
    const ghostIdentifier = 'summary';
    const tag = prepareGhostTag(code, ghostIdentifier);

    useEffect(() => {
        getPagesByTag([tag]).then(pages => {
            if (pages.length > 0) {
                setGhostPage(pages[0]!);
            }
        });
    }, [tag]);

    if (!ghostPage && !description) {
        return null;
    }

    return (
        <>
            <PriceSectionHeader title={`about ${title}`} />
            <section className="py-8">
                <h3 className="truncate text-xl font-headline px-8 leading-9">What is {title}?</h3>
                <div className="px-8 mt-2">
                    {ghostPage ? (
                        <GhostPage fetchedGhostPage={ghostPage} className="leading-loose" fullWidth />
                    ) : (
                        <RenderContent html={description} className="leading-loose" fullWidth />
                    )}
                </div>
            </section>
        </>
    );
};

export default PriceAboutSummary;
